import { useDispatch, useSelector } from 'react-redux';
import styles from './WebinarsYearFilter.module.scss';
import { setYearFilterWebinars } from '../../../../redux/Reducers/webinarsReducer';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const WebinarsYearFilter = () => {
  const dispatch = useDispatch();
  const filterYear = useSelector((state) => state.webinars.filterYearWebinars);
  const webinarsList = useSelector((state) => state.webinars.webinars);
  const years = [...new Set(webinarsList.map((webin) => new Date(webin.date).getFullYear()))].sort((a, b) => b - a);

  const handleSetYearFilter = (year) => {
    dispatch(setYearFilterWebinars(year));
  };

  if (years.length === 0 || years.length === 1) {
    return <></>;
  }

  return (
    <div className={classnames(isMobile ? [styles.box, styles.mobile] : [styles.box])}>
      <h3 className={styles.title}>Архив</h3>
      <button
        onClick={() => handleSetYearFilter(null)}
        className={classnames(filterYear === null ? [styles.allYears, styles.active] : [styles.allYears])}>
        Все года
      </button>

      {years.map((year) => {
        return (
          <button
            key={year}
            onClick={() => handleSetYearFilter(year)}
            className={classnames(filterYear === year ? [styles.yearItem, styles.active] : [styles.yearItem])}>
            {year}
          </button>
        );
      })}
    </div>
  );
};

export default WebinarsYearFilter;
